import { render, staticRenderFns } from "./WineEdit.vue?vue&type=template&id=39bf54be&"
import script from "./WineEdit.vue?vue&type=script&lang=js&"
export * from "./WineEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports